<template>
    <b-container>
        <b-row style="margin-top:50px">
            <b-col>
                <h4>Invoices</h4>
            </b-col>
        </b-row>
        <!-- Invoices table -->
        <b-row v-if="invoicesArray.length<1">
            <b-col>No invoices created yet. You can create an invoice from the Orders page</b-col>
        </b-row>
        <b-row v-if="invoicesArray.length>0">
            <table class="table table-striped">
                <thead class="thead-dark">
                    <tr>
                        <th>Date</th>
                        <th>From</th>
                        <th>Number</th>
                        <th>Cost</th>
                        <th>Mark Paid</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="invoice in invoicesArray" :key="invoice.invoicenumber" style="cursor:pointer" @click="showInvoiceNumber(invoice.invoicenumber, invoice)">
                        <td>{{invoice.date.date}} {{invoice.date.month}}</td>
                        <td>{{invoice.brewer}}</td>
                        <td><small>{{invoice.invoicenumber}}</small></td>
                        <td>${{invoice.total}}</td>
                        <td>
                            <b-button v-if='invoice.paid!=1' v-b-modal="'MarkPaid' + invoice.invoicenumber"  v-b-tooltip.hover title="Mark Paid" class='btn btn-success action-buttons'><i><font-awesome-icon icon="dollar-sign" /></i></b-button>
                                <span v-if="invoice.paid==1" style="color:grey">Already Paid</span>
                                <b-modal :id="'MarkPaid' + invoice.invoicenumber" title="Mark Paid" 
                                    ok-title ='Yes, Mark As Paid'  @ok="markPaid(invoice.invoicenumber)" >
                                    <p class="my-4">Mark this order as paid?</p>
                                </b-modal>
                        </td>
                    </tr>
                </tbody>
            </table>
        </b-row>
        
    </b-container>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../../firebaseConfig.js')
    import {timeConverterObject} from '../Myfunctions'
    export default {
        components: {
            },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        data() {
            return {
                invoicesArray:[],
                }
        },
        methods:{
            getUserInvoices(){
                var idforinvoices = this.currentUser.uid
                if(this.userProfile.isbrewer==10) idforinvoices = this.userProfile.distributorid

                fb.invoicesCollection.where('brewerid', '==', idforinvoices).orderBy("createdOn", "desc").get().then(docs => {
                    this.loadingPage=false
                    docs.forEach(doc => {
                        let invoice = doc.data()
                        invoice.docId = doc.id
                        invoice.date = timeConverterObject(invoice.createdOn.seconds)
                        this.invoicesArray.push(invoice)
                    })
                }).then(res => {
                })
            },
            showInvoiceNumber(invoicenumber, invoice){
                this.$router.push({ path: 'showinvoice', query: { invoicenumber: invoicenumber, invoicedocid: invoice.docId }})
            }
        },

        mounted(){
            this.getUserInvoices()
        }

        
    }
</script>